import { useTheme as originalUseTheme } from "@mui/material/styles"

export const useTheme = () => {
   // some weird compatibility issues between useTheme, esbuild, vite, and esm modules in general, are making useTheme to be exported as 
   // an object like this {__esModule: true, default: f()}, being f() the actual function
   const actualUseTheme = typeof originalUseTheme === 'function' ? originalUseTheme : ((originalUseTheme as any).default as typeof originalUseTheme)
   return actualUseTheme()
}

export type { Theme } from "@mui/material/styles"